/*
* DialogPlayerContentEvent.js
* Created on 9-3-2021
* @author reinier@ranj.nl
*/

import CollaborationDialogPlayer from "../CollaborationDialogPlayer";
import DialogMemento from "../DialogMemento";

export default class DialogPlayerRegisterEvent {
    /**
     * @param {String} type 
     * @param {CollaborationDialogPlayer} dialogPlayer 
     * @param {DialogMemento} dialogMemento
     */
    constructor(type, dialogPlayer, dialogMemento) {
        this.type = type;
        this.dialogPlayer = dialogPlayer;
        this.dialogMemento = dialogMemento
    }
}

DialogPlayerRegisterEvent.REGISTER = "DialogPlayerRegisterEvent.REGISTER";
DialogPlayerRegisterEvent.DEREGISTER = "DialogPlayerRegisterEvent.DEREGISTER";